export const NotificationType = [
  'event-new',
  'event-end',
  'event-validated',
  'event-post',

  'group-new'
] as const

export const NotificationPriority = [
  'normal',
  'high'
] as const
export interface INotification {
  _id: string
  type: typeof NotificationType[number]
  priority: typeof NotificationPriority[number]

  formatted: {
    title: string
    content: string
    link: string
    image: string
  }

  event: string
  post: string
  users?: string[]

  meta?: {
    [key: string]: string | number | Date
  }
  
  readAt?: Date
  createdAt: Date
}

export interface Notification extends INotification {}

export class Notification implements INotification {
  
  constructor (props: INotification) {

    Object.assign(this, {
      ...props
    })
  }
}